/**
 * Ui Helper popover.
 *
 * Call it through the shared service UiHelper.
 */
angular.module('hjApp').directive('uiHelper', [
    '$rootScope',
    '$timeout',
    'LocalStorage',
    function ($rootScope, $timeout, LocalStorage) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            template:
                '<div id="ui-helper" class="pop-over {{ placement }}" style="{{ style }}" ng-show="visible">' +
                '<div class="close" ng-click="hideAndRemember(identifier);">&times;</div>' +
                '<div class="title"><span class="icon-info blue"></span>{{ title }}</div>' +
                '<p class="message" ng-bind-html="message"></p>' +
                '<a class="cta" ng-click="ctaFunction()" ng-show="ctaText && ctaFunction">' +
                '{{ ctaText }}' +
                '</a>' +
                '</div>',
            link: function (scope) {
                var zIndex;

                /*************************
                 * PRIVATE FUNCTIONS
                 *************************/
                /**
                 * Hide the UI Helper from view.
                 */
                function hide() {
                    if (scope.visible) {
                        // Update the scope using the timeout 0 hack.
                        $timeout(function () {
                            scope.visible = false;
                            if (scope.hideOnAnchorClick) {
                                scope.anchor.unbind('.hideEvent');
                            }
                        }, 0);
                    }
                }

                /**
                 * Remove any marker there is for this helper.
                 */
                function hideMarker(identifier) {
                    var marker = $('.helper-ui-marker[data-ui-helper-anchor="' + identifier + '"]');
                    if (scope.identifier === identifier) {
                        marker.remove();
                    }
                }

                /*************************
                 * SCOPE FUNCTIONS
                 *************************/
                /**
                 * Hide the UI Helper and remember this in the browser's LocalStorage.
                 */
                scope.hideAndRemember = function (identifier) {
                    if (scope.identifier === identifier) {
                        hideMarker(identifier);
                        hide();

                        // Remember that this helper was shown and closed.
                        LocalStorage.set(identifier, true);
                    }
                };

                /*************************
                 * LISTENERS
                 *************************/
                /**
                 * Show a helper if the user has not already seen and dismissed it.
                 */
                $rootScope.$on(
                    'hjUiHelper',
                    function (
                        event,
                        identifier,
                        title,
                        message,
                        placement,
                        customZIndex,
                        positionAdjustment,
                        forceShow,
                        alwaysShow,
                        hideOnAnchorClick,
                        ctaText,
                        ctaFunction,
                        showOnce
                    ) {
                        zIndex = customZIndex || 700000;

                        // Do nothing if there is a uiHelper already visible.
                        if (scope.visible && !forceShow) {
                            return;
                        }

                        scope.hideOnAnchorClick = hideOnAnchorClick;
                        scope.identifier = identifier;
                        scope.title = title;
                        scope.message = message;
                        scope.placement = placement || 'bottom-right';
                        scope.ctaText = ctaText;

                        if (_.isFunction(ctaFunction)) {
                            scope.ctaFunction = function () {
                                hideMarker(scope.identifier);
                                scope.hideAndRemember(scope.identifier);
                                scope.anchor.unbind('.hideEvent');
                                ctaFunction();
                            };
                        }

                        positionAdjustment = positionAdjustment || [0, 0];

                        // When Ui Helpers are hidden, we store their identifiers in LocalStorage,
                        // so we check if this one has been already shown or not.
                        // If alwaysShow is set, we just ignore LocalStorage and show it anyway.
                        if (alwaysShow || !LocalStorage.get(scope.identifier)) {
                            scope.anchor = $('[data-ui-helper-anchor=' + scope.identifier + ']');

                            // Only proceed to display the helper if the html anchor is present in the dom.
                            if (scope.anchor.length > 0) {
                                // Show the UI Helper.
                                scope.visible = true;

                                setPlacement(scope, positionAdjustment, zIndex);

                                if (showOnce) {
                                    $timeout(function () {
                                        LocalStorage.set(scope.identifier, true);
                                    }, 1000);
                                }

                                // Hide the UI helper when the anchor is clicked.
                                if (scope.hideOnAnchorClick) {
                                    scope.anchor.bind('click.hideEvent', function () {
                                        hideMarker(scope.identifier);
                                        scope.hideAndRemember(scope.identifier);
                                        scope.anchor.unbind('.hideEvent');
                                    });
                                }
                            }
                        }
                    }
                );

                /**
                 * Initialize (show) any page markers.
                 */
                $rootScope.$on('initMarkers', function () {
                    var identifier,
                        marker,
                        markers = $('.helper-ui-marker[data-ui-helper-anchor]');

                    // Loop through all the markers.
                    _.each(markers, function (elem) {
                        marker = $(elem);
                        identifier = marker.attr('data-ui-helper-anchor');

                        // Determine whether this marker should show or not.
                        if (identifier && !LocalStorage.get(identifier)) {
                            marker.show();
                        }
                    });
                });

                $rootScope.$on('hideHelpers', hide);
                $rootScope.$on('$stateChangeStart', hide);
            }
        };

        /**
         * Set the placement of the UI helper on scope.
         *
         * @param {Object} scope The scope object - will be modified
         * @param {Object} anchorAttrs The attributes
         * @param {number[]} positionAdjustment Move the UI helper by [top, bottom]
         * @param {number} zIndex The z-index value
         */
        function setPlacement(scope, positionAdjustment, zIndex) {
            var uiHelperWidth = 300,
                uiHelperHeight = null,
                anchorAttrs = {};

            // Get the position and dimensions of the anchor element;
            anchorAttrs = {
                w: scope.anchor.outerWidth(),
                h: scope.anchor.outerHeight(),
                x: scope.anchor.offset().left,
                y: scope.anchor.offset().top
            };

            scope.style = 'z-index: ' + zIndex + ';';
            if (scope.placement === 'bottom-left') {
                scope.style +=
                    'top: ' +
                    (anchorAttrs.h + anchorAttrs.y - 2 + positionAdjustment[0]) +
                    'px;' +
                    'left: ' +
                    (anchorAttrs.x - uiHelperWidth + anchorAttrs.w + positionAdjustment[1]) +
                    'px;';
            } else if (scope.placement === 'bottom-right') {
                scope.style +=
                    'top: ' +
                    (anchorAttrs.h + anchorAttrs.y - 2 + positionAdjustment[0]) +
                    'px;' +
                    'left: ' +
                    (anchorAttrs.x - 5 + positionAdjustment[1]) +
                    'px;';
            } else if (scope.placement === 'top-left') {
                $timeout(function () {
                    uiHelperHeight = $('#ui-helper').outerHeight();
                    scope.style +=
                        'top: ' +
                        (anchorAttrs.y - anchorAttrs.h - uiHelperHeight + positionAdjustment[0]) +
                        'px;' +
                        'left: ' +
                        (anchorAttrs.x - uiHelperWidth + anchorAttrs.w + positionAdjustment[1]) +
                        'px;';
                });
            } else if (scope.placement === 'right') {
                scope.style +=
                    'top: ' +
                    (anchorAttrs.y + positionAdjustment[0]) +
                    'px;' +
                    'left: ' +
                    (anchorAttrs.x + anchorAttrs.w + positionAdjustment[1]) +
                    'px;';
            } else if (scope.placement === 'top-right') {
                scope.style += 'visibility: hidden;';
                $timeout(function () {
                    uiHelperHeight = $('#ui-helper').outerHeight();
                    scope.style +=
                        'top: ' +
                        (anchorAttrs.y - anchorAttrs.h - uiHelperHeight + positionAdjustment[0]) +
                        'px;' +
                        'left: ' +
                        (anchorAttrs.x - 5 + positionAdjustment[1]) +
                        'px; visibility: visible;';
                });
            }
        }
    }
]);
